import clsx from 'clsx';
import DOMPurify from 'dompurify';
import { bool, string } from 'prop-types';
import { useEffect } from 'react';

import { useSafeState } from 'hooks';

const SanitizedHtml = ({ content = '', className = '', filterEmpty = false }) => {
  const [sanitizedContent, setSanitizedContent] = useSafeState(null);

  const sanitizeConfig = { ADD_ATTR: ['target'] };

  useEffect(() => {
    if (filterEmpty) {
      let text = DOMPurify.sanitize(content, sanitizeConfig);
      // Remove <p>&nbsp;</p> from content or any other empty paragraph
      text = text?.replace(/<p>&nbsp;<\/p>/g, '')?.replace(/<p><\/p>/g, '') || '';
      setSanitizedContent(text);
    } else {
      const contentWithLineBreaks = content?.replace(/\r\n/g, '<p></p>') || '';
      setSanitizedContent(DOMPurify.sanitize(contentWithLineBreaks, sanitizeConfig));
    }
  }, [filterEmpty, content]);

  if (!sanitizedContent) return null;

  return <div dangerouslySetInnerHTML={{ __html: sanitizedContent }} className={clsx('html-content', className)} />;
};

SanitizedHtml.propTypes = {
  content: string,
  className: string,
  filterEmpty: bool
};

export default SanitizedHtml;
